import { Grid } from "@mui/material";
import React, { Suspense, lazy, useEffect, useState } from "react";
import FTheader from "./Component/header";
import Banner from "./Component/banner";
import "./index.css";

import tokenomicsBack from "../../assests/Images/tokenomics-back.webp";
import useMediaQuery from "@mui/material/useMediaQuery";
import Media from "./Component/Media";
import ScrollReveal from "./Component/ScrollReveal";
import SectionDividerCoin from "./Component/SectionDividerCoin";
import TeamSeamCoin from "./Component/TeamSeamCoin";
import ChapterSlide from "./Component/ChapterSlide";
import useActiveChapter from "./hooks/useActiveChapter";
import { scrollToSection } from "./utils/scrollToSection";

const FloatingFlashCoin = lazy(() => import("./Component/FloatingFlashCoin"));
const SiteMotion = lazy(() => import("./Component/SiteMotion"));

const FlashEcosystem = lazy(() => import("./Component/FlashEcosystem"));
const FlashList = lazy(() => import("./Component/Flashlist"));
const ListingPartners = lazy(() => import("./Component/Listing&Partners"));
const FlashTransfer = lazy(() => import("./Component/FlashTransfer"));
const FlashWallet = lazy(() => import("./Component/FlashWallet"));
const Roadmap = lazy(() => import("./Component/Roadmap"));
const Tokenomics = lazy(() => import("./Component/Tokenomics"));
const FlashRecharge = lazy(() => import("./Component/FlashRecharge"));
const InvestFuture = lazy(() => import("./Component/InvestFuture"));
const NFTutility = lazy(() => import("./Component/Nftutility"));
const CoreTeams = lazy(() => import("./Component/CoreTeam"));
const CoreTeamMember = lazy(() => import("./Component/CoreTeamMember"));
const DevTeam = lazy(() => import("./Component/DevTeam"));
const Faq = lazy(() => import("./Component/Faq"));
const ContactUs = lazy(() => import("./Component/ContactUs"));
const Footer = lazy(() => import("./Component/Footer"));

function SectionFallback() {
  return <div className="section-fallback" aria-hidden="true" />;
}

const FlashToken = () => {
  const tokenomicsBreakpoint = useMediaQuery("(max-width : 1199px)");
  const activeChapter = useActiveChapter();
  // Defer scroll-coin + site motion until idle so they don't block LCP/TBT.
  const [motionReady, setMotionReady] = useState(false);

  useEffect(() => {
    document.documentElement.classList.add("flash-charge-journey");
    return () => {
      document.documentElement.classList.remove("flash-charge-journey");
    };
  }, []);

  useEffect(() => {
    const hash = window.location.hash.replace("#", "");
    if (!hash) return undefined;
    let attempts = 0;
    const tryScroll = () => {
      const el =
        document.getElementById(hash) ||
        document.getElementById(hash.toLowerCase());
      if (el) {
        scrollToSection(hash, 80);
        return;
      }
      if (attempts < 20) {
        attempts += 1;
        window.setTimeout(tryScroll, 150);
      }
    };
    tryScroll();
    return undefined;
  }, []);

  useEffect(() => {
    let cancelled = false;
    const enable = () => {
      if (!cancelled) setMotionReady(true);
    };
    if (typeof window !== "undefined" && "requestIdleCallback" in window) {
      const id = window.requestIdleCallback(enable, { timeout: 2200 });
      return () => {
        cancelled = true;
        window.cancelIdleCallback?.(id);
      };
    }
    const t = window.setTimeout(enable, 1200);
    return () => {
      cancelled = true;
      window.clearTimeout(t);
    };
  }, []);

  return (
    <>
      {motionReady ? (
        <Suspense fallback={null}>
          <FloatingFlashCoin chapterId={activeChapter} />
          <SiteMotion activeChapter={activeChapter} />
        </Suspense>
      ) : null}
      {/* Fixed media bar must sit outside overflow/transform parents */}
      <Media />
      {/* overflowX only — overflow:hidden blocks window scrollIntoView / nav jumps */}
      <Grid
        container
        component="main"
        id="main-content"
        style={{ overflowX: "hidden" }}
      >
        <Grid
          item
          md={12}
          sx={{
            width: "100%",
            maxWidth: "100vw",
            marginTop: { xs: "70px", lg: "0px" },
          }}
        >
          <ChapterSlide id="hero" active={activeChapter === "hero"}>
            <Grid
              id="hero"
              sx={{
                backgroundColor: "#121212",
                backgroundImage:
                  "radial-gradient(ellipse 70% 55% at 50% 45%, #2a261a 0%, #181818 55%, #0f0f0f 100%)",
                position: "relative",
              }}
            >
              <FTheader />
              <Banner />
            </Grid>
          </ChapterSlide>

          <Suspense fallback={<SectionFallback />}>
            <ChapterSlide id="ecosystem" active={activeChapter === "ecosystem"}>
              <Grid id="services" sx={{ backgroundColor: "#0F0F0F" }}>
                <ScrollReveal direction="up" delay={0.05}>
                  <FlashEcosystem />
                </ScrollReveal>
              </Grid>
              <Grid sx={{ backgroundColor: "#181818" }}>
                <ScrollReveal direction="fade" delay={0.05} duration={0.7}>
                  <FlashList />
                </ScrollReveal>
              </Grid>
              <Grid id="partners" sx={{ backgroundColor: "black" }}>
                <ScrollReveal direction="up">
                  <ListingPartners />
                </ScrollReveal>
              </Grid>
              <Grid id="transfer" sx={{ backgroundColor: "black" }}>
                <ScrollReveal direction="left" amount={0.12}>
                  <FlashTransfer />
                </ScrollReveal>
              </Grid>
              <Grid id="wallet" sx={{ backgroundColor: "black" }}>
                <ScrollReveal direction="right" amount={0.12}>
                  <FlashWallet />
                </ScrollReveal>
              </Grid>
            </ChapterSlide>

            <ChapterSlide id="launch" active={activeChapter === "launch"}>
              <Grid
                sx={{
                  backgroundColor: "#181818",
                  position: "relative",
                  overflow: "visible",
                  paddingBottom: 0,
                }}
                id="roadmap"
              >
                <ScrollReveal direction="scale" style={{ overflow: "visible" }}>
                  <Roadmap />
                </ScrollReveal>
              </Grid>

              <SectionDividerCoin />

              <Grid
                id="tokenomics"
                sx={{
                  backgroundImage: `url(${tokenomicsBack})`,
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                  position: "relative",
                  zIndex: 1,
                }}
              >
                <div
                  aria-hidden
                  style={{
                    width: "100%",
                    height: "40px",
                    position: "absolute",
                    bottom: "100%",
                    left: 0,
                    backgroundColor: "black",
                    zIndex: 2,
                    display: `${tokenomicsBreakpoint ? "none" : "block"}`,
                  }}
                ></div>
                <ScrollReveal direction="up">
                  <Tokenomics />
                </ScrollReveal>
              </Grid>

              <Grid sx={{ backgroundColor: "#181818" }}>
                <ScrollReveal direction="left">
                  <FlashRecharge />
                </ScrollReveal>
              </Grid>

              <Grid sx={{ backgroundColor: "black" }}>
                <ScrollReveal direction="up">
                  <InvestFuture />
                </ScrollReveal>
              </Grid>
              <Grid id="nft" sx={{ backgroundColor: "black" }}>
                <ScrollReveal direction="scale">
                  <NFTutility />
                </ScrollReveal>
              </Grid>
            </ChapterSlide>

            <ChapterSlide id="trust" active={activeChapter === "trust"}>
              <Grid sx={{ backgroundColor: "black" }}>
                <ScrollReveal direction="fade" duration={0.65}>
                  <CoreTeams />
                </ScrollReveal>
              </Grid>
              <Grid id="team" sx={{ backgroundColor: "#181818" }}>
                <ScrollReveal direction="up">
                  <CoreTeamMember />
                </ScrollReveal>
              </Grid>

              {/* Flash seal + scroll-coin dock on Core Team / DevTeam seam */}
              <TeamSeamCoin />

              <Grid
                sx={{
                  backgroundColor: "black",
                  position: "relative",
                  paddingBottom: { lg: "60px" },
                }}
              >
                <ScrollReveal direction="up" delay={0.05}>
                  <DevTeam />
                </ScrollReveal>
              </Grid>
            </ChapterSlide>

            <ChapterSlide id="connect" active={activeChapter === "connect"}>
              <Grid
                id="faq"
                sx={{ backgroundColor: { lg: "#181818", xs: "black" } }}
              >
                <ScrollReveal direction="up">
                  <Faq />
                </ScrollReveal>
              </Grid>
              <Grid
                id="Contact"
                sx={{ backgroundColor: "black", position: "relative" }}
              >
                <ScrollReveal direction="up">
                  <ContactUs />
                </ScrollReveal>
              </Grid>
              <Grid
                sx={{
                  backgroundColor: "#181818",
                  paddingBottom: { lg: "140px", xs: "120px" },
                }}
              >
                <ScrollReveal direction="fade" duration={0.7}>
                  <Footer />
                </ScrollReveal>
              </Grid>
            </ChapterSlide>
          </Suspense>
        </Grid>
      </Grid>
    </>
  );
};

export default FlashToken;
